import axios from 'axios';

export const getStates = () => {
  return axios.get('/orders/states');
};
